import { IntlShape } from 'react-intl';
import { object as YupObject, string as YupString } from 'yup';

import { emailValidationRegex } from 'app/shared/utils/emailValidation';

export const NewsletterValidationSchema = ({
  intl,
  withCity,
}: {
  intl: IntlShape;
  withCity: boolean;
}) =>
  YupObject().shape({
    email: YupString()
      .matches(emailValidationRegex, {
        message: intl.formatMessage(
          {
            id: 'form.fieldMustBeValidEmail',
          },
          {
            field: 'Email',
          }
        ),
      })
      .required(intl.formatMessage({ id: 'newsletter.form.emailRequired' })),
    city: YupObject()
      .nullable()
      .test(
        'city',
        intl.formatMessage({ id: 'newsletter.form.cityRequired' }),
        (value) => (withCity ? !!value : true)
      ),
  });
